import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, mergeMap, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { ApiService } from '../../../core/http/api.service';
import {
  GetSimilarPropertiesResponseModel,
  SimilarPropertiesParamsModel
} from '../../../shared/models/properties/properties.models';
import { SimilarPropertiesActions } from '../../actions/property/similar-properties.actions';

@Injectable()
export class SimilarPropertiesEffects {

  loadSimilarProperties$ = createEffect(() => this.actions$
    .pipe(
      ofType(SimilarPropertiesActions.loadSimilarProperties),
      mergeMap(
        (data: SimilarPropertiesParamsModel) => this.api.Properties.getSimilarProperties(data)
          .pipe(
            map((response: GetSimilarPropertiesResponseModel) => SimilarPropertiesActions.loadSimilarPropertiesSuccess(response)),
            catchError(error => of(SimilarPropertiesActions.loadSimilarPropertiesFailure(error)))
          )
      )
    ));

  constructor(
    private actions$: Actions,
    private api: ApiService
  ) { }
}
